<template>
    <p>
        <slot/>
    </p>
</template>
<script>
    export default {
        name: "SimpleText"
    }
</script>